import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* withdrawalFromSavingsAccount(action: ActionInterface): any {

  try {

    yield put({ type: Constants.GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_REQUEST })

    const res = yield call(Http.post, `savings/${action.payload?.companyId}/withdrawal`, {
      amount: action.payload?.amount,
    });

    yield put({ type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS })
    yield put({ type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS })
    yield put({ type: Constants.GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_SUCCESS })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_FAILURE,
      payload: { err: err }
    });

  }

}

export function* watchWithdrawalFromSavingsAccount() {
  yield takeEvery(Constants.GLOBAL_WITHDRAWAL_FROM_SAVINGS_ACCOUNT_START, withdrawalFromSavingsAccount);
}
